
import { Component, Vue } from "vue-property-decorator";
import ebInput from "@/components/FormElements/Input.vue";
import axios from "axios";
import { NIPIGE_CAP } from "../../config";

@Component({
  components: {
    ebInput
  }
})
export default class ChangePassword extends Vue {
  private currentpassword = "";
  private newpassword = "";
  private confirmpassword = "";

  public changePassword() {
    if (sessionStorage.getItem("nipige:forcechangepass")) {
      let type = JSON.parse(
        sessionStorage.getItem("nipige:forcechangepass") as any
      );
      const dataObj = {
        currentPassword: this.currentpassword,
        newPassword: this.newpassword
      };
      const config = {
        headers: {
          Authorization: type.token
        }
      };
      console.log(dataObj, NIPIGE_CAP);

      axios
        .post(
          `${NIPIGE_CAP}/users/partner/update-password`,
          dataObj,
          config
        )
        .then(response => {
          if (response) {
            this.$router.push("login");
          }
        })
        .catch(() => {
          this.$router.push("login");
        });
    }
  }
}
